import React, {Component} from 'react';
import PropTypes from 'prop-types';
import './Notice.scss';
import classNames from 'classnames';
import moment from 'moment';
import Gazprom from '../../assets/img/gz.png';
import RN from '../../assets/img/rn.png';


class Notice extends Component {
    static propTypes = {
        notice: PropTypes.object,
        idx: PropTypes.number,
        handle: PropTypes.func,
        active: PropTypes.bool,
    }

    constructor(props) {
        super(props)

        moment.locale('ru');

        this.role = {
            vendor: 'Поставщик',
            factor: 'Фактор',
            debtor: 'Покупатель',
        }

        this.state = {
            activeCard: false,
        }
    }

    reformatDate = date => {
        const now = moment().format('DD.MM.YYYY');
        const yesterday = moment().add(-1, 'days').format('DD.MM.YYYY');
        const tmp = moment(date).format('DD.MM.YYYY');
        return tmp === now ?
            'Сегодня' : yesterday === tmp ?
                'Вчера' : tmp
    }

    render() {
        const {notice, idx, active, handle} = this.props;
        const {title, roleFrom, viewStatus, nameCompany, logo, date, status} = notice;
        const logoImg = logo === 'rn' ? (<img src={RN} alt={''}/>) : logo === 'gaz' ? (<img src={Gazprom} alt={''}/>) : (<img src={Gazprom} alt={''}/>);
        const reformateDate = this.reformatDate(date);
        return (
            <div className={classNames('noticeCard',
                {'new': viewStatus === 'new'})}
                onClick={() => handle(idx)}>
                <div className={classNames('mainBlock', {
                    'active': active
                })}>
                    <div className={'titleNotice'}>
                        {title}
                    </div>
                    <div className={'roleForm'}>
                        {this.role[roleFrom]}
                    </div>
                    <div className={'nameCompany'}>
                        {nameCompany}
                    </div>
                </div>
                <div className={'secondBlock'}>
                    <div className={'top'}>
                        <div className={'date'}>
                            {reformateDate}
                        </div>
                        <div className={classNames('status', status)}/>

                    </div>
                    <div className={'icon'}>{logoImg}</div>
                </div>

            </div>
        )
    }
}

export default Notice;



// WEBPACK FOOTER //
// ./src/shared/Notice/Notice.js